import "./scss/WheelOfPrizes.scss";
import SubmitButton from "./SubmitButton";

function WheelOfPrizesRetry({ tryAgain, data, button }) {
	return (
		<>
			<div style={{ marginTop: data?.marginTop }} className="wheel_ofprizes-lost">
				<div>
					<h3>Δεν κέρδισες αυτή τη φορά</h3>
					<h3>Έχεις άλλη μια προσπάθεια</h3>
				</div>
				<div>
					<h3>This wasn't your lucky spin</h3>
					<h3>Please try again</h3>
				</div>
			</div>
			<div className="text--center" style={{ position: 'fixed', bottom: '64px', left: 0, right: 0 }} >
				<SubmitButton
					text="Try again"
					size={button?.submitSize}
					onSubmit={tryAgain}
					buttonStyle={{borderRadius:button?.borderRadius, background: data?.buttonColor, color: data?.textColor}}
				/>
			</div>
		</>
	);
};
export default WheelOfPrizesRetry;
